export default "__VITE_ASSET__DK$AZJiT__"